module.exports = __webpack_public_path__ + "img/ar13.f7480b9a.jpg";